module.exports = __webpack_public_path__ + "static/media/black_transition.66c562f5.png";